/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// @ts-nocheck
import { makeRequest } from "@/utils/axiosInterceptor";

async function getUserData() {
    try {
        const accessRoute = '/users'
        const { data: allUsers } = await makeRequest("GET", accessRoute, "");
        console.log(allUsers)
        return allUsers.reverse();
    } catch (error) {
        console.error("Error fetching instances:", error);
        return [];
    }
}
export default getUserData;
